var goToUrl = function goToUrl(url) {
  if (window.Cypress) {
    window.history.replaceState({}, '', url);
  } else {
    window.location.href = url;
  }
};

export { goToUrl };
